import React, { Component } from 'react';

import { logEvent } from '@firebase/analytics';
import { Typography, Stack } from '@mui/material';
import Lottie from 'react-lottie';

import analytics from '../firebase';
import animationData from '../lotties/error.json';

export class BrokenAnimation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStopped: false,
      isPaused: false
    };
    logEvent(analytics, 'SOMETHING_BROKEN');
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return (
      <Stack display="flex" justifyContent="center" alignItems="center">
        <Lottie
          options={defaultOptions}
          height={'30%'}
          width={'30%'}
          speed={4}
          isStopped={this.state.isStopped}
          isPaused={this.state.isPaused}
        />
        <Typography variant="h6" sx={{ color: '#f0b927' }}>
          {this.props.loadingMessage}
        </Typography>
      </Stack>
    );
  }
}
